import apiClient from './api-client';

class IVeriService {
    setupRecurringPayment(payload) {
        return apiClient.post('/payment/recurring/setup', payload);
    }

    toggleStatus(policyNumber, activate) {
        return apiClient.put(`/payment/recurring/${policyNumber}/status?activate=${activate}`);
    }

    retryFailedRecurringPayment(policyNumber) {
        return apiClient.post(`/payment/recurring/${policyNumber}/retry`);
    }

    deleteRecurringPayment(policyNumber) {
        return apiClient.delete(`/payment/recurring/${policyNumber}`);
    }

    getUserRecurringPayments() {
        return apiClient.get('/payment/recurring/user');
    }
}

export default new IVeriService();
